// extracted by mini-css-extract-plugin
export var content = "_dl-3";
export var list = "_dl-4";
export var settingsContent = "_dl-7";
export var settingsPanel = "_dl-8";
export var state = "_dl-6";
export var triggerBadge = "_dl-2";
export var triggerButton = "_dl-1";
export var triggerShell = "_dl-0";
export var unreadDot = "_dl-5";